import ChatBubbleIcon from "@/assets/icons/chat-bubble.svg";
import AlertShareExportCard from "@components/AlertShareExportCard";

import { CSV, Excel } from "./links";

const Export = () => {
  return (
    <AlertShareExportCard.Root>
      <AlertShareExportCard.Left>
        <AlertShareExportCard.Icon icon={ChatBubbleIcon} />
        <AlertShareExportCard.LeftText>
          <AlertShareExportCard.Title>
            {L.EXPORT_ALERT_MODAL_MENTIONS}
          </AlertShareExportCard.Title>
        </AlertShareExportCard.LeftText>
      </AlertShareExportCard.Left>

      <AlertShareExportCard.Right>
        <Excel />
        <CSV />
      </AlertShareExportCard.Right>
    </AlertShareExportCard.Root>
  );
};
export default Export;
